export interface JsonContractSector {
  id: string;
  name: string;
}

export class ContractSector {
  id: string;
  name: string;

  constructor(jsonContractSector: JsonContractSector = null) {
    if (jsonContractSector) {
      this.id = jsonContractSector.id;
      this.name = jsonContractSector.name;
    }
  }
}
